import { TiktokStandardEvents } from '@xyo-network/sdk-xyo-react-js';
class TiktokEvents extends TiktokStandardEvents {
}
export default TiktokEvents;
//# sourceMappingURL=index.js.map